import React from 'react';
import { bool, number, object, string, oneOfType } from 'prop-types';
import { mapRouterType } from 'config/constants';
import MapRouterPathGuide from 'containers/MapRouter';
import MapRouterGeneral from 'containers/MapRouterGeneral';

MapRouterMaster.propTypes = {
  type: string,
  rotate: number,
  slotInfo: object,
  hideTravelBar: bool,
  bannerSrc: oneOfType([string, bool]),
  layout: string,
  destinationName: string,
  floorIndex: number,
  locationsHighlighted: string,
};

function MapRouterMaster(props) {
  const { type, ...restProps  } = props;
  return (
    <>
      {/**
       *  For showing genral information of the floors like map, facilities...
       */}    
      {type === mapRouterType.overview && (<MapRouterGeneral {...restProps} />)}

      {/**
       *  For spec where the app need to show definite path from place to place
       */}
      {type === mapRouterType.pathGuide && (<MapRouterPathGuide {...restProps} />)}
    </>
  );
}

export default MapRouterMaster;